<template>
    <div>
        <!--<div class="flex pad14 alc" id="toolH">
            <el-select style="width: 145px" @change="changeData($event,'state')" @clear="clearsearch('gs')" class="marr4" v-model="vc_checkstate" size="mini" clearable filterable placeholder="请选择">
                <el-option
                        v-for="item in stateData"
                        :key="item.i_checkstate"
                        :label="item.vc_name"
                        :value="item.i_checkstate">
                </el-option>
            </el-select>
            <el-date-picker
                    style="width: 220px"
                    class="marr4"
                    size="mini"
                    v-model="valuetime"
                    @change="getTimes"
                    :clearable="false"
                    type="daterange"
                    :range-separator="$t('form_to')"
                    :start-placeholder="$t('form_start_date')"
                    :end-placeholder="$t('form_end_date')">
            </el-date-picker>
            <el-input  class="marr4" style="width: 195px"  v-model="vc_search" placeholder="请输入客户名称/发票编号/品名搜索" clearable size="mini"></el-input>
            <el-button class="marr4" icon="el-icon-search" circle  @click="gosearch" size="mini"></el-button>
        </div>-->
        <el-table
                v-loading="loading"
                ref="table"
                size="mini"
                border
                :data="tableData"
                :height="tableHeight"
                :header-cell-style="{background:'#eef1f6',color:'#000'}"
                :highlight-current-row="highlightCurrentRow">
            <el-table-column
                    type="index"
                    :label="$t('form_serial_number')"
                    show-overflow-tooltip
                    width="55">
            </el-table-column>
            <el-table-column
                    prop="i_type_zh"
                    :label="$t('invoiceEntry_billing_type')"
                    show-overflow-tooltip
                    width="120">
            </el-table-column>
            <el-table-column
                    prop="vc_fptype"
                    :label="$t('invoiceEntry_invoice_type')"
                    show-overflow-tooltip
                    width="130">
            </el-table-column>
            <!--<el-table-column
                    prop="i_invoiceType"
                    :label="$t('invoiceEntry_invoice_type')"
                    show-overflow-tooltip>
                <template slot-scope="scope">
                    <span>{{scope.row.i_invoiceType==1?"蓝字":(scope.row.i_invoiceType==2?"红字":"")}}</span>
                </template>
            </el-table-column>-->
            <!--<el-table-column
                    prop="vc_checkstate"
                    :label="$t('form_state')"
                    width="80px"
                    show-overflow-tooltip>
            </el-table-column>-->
            <el-table-column
                    prop="vc_kpkhname"
                    :label="$t('invoiceEntry_issuer')"
                    show-overflow-tooltip
                    min-width="210">
            </el-table-column>
            <el-table-column
                    prop="vc_gsname"
                    :label="$t('invoiceEntry_payer')"
                    show-overflow-tooltip
                    min-width="210">
            </el-table-column>
            <el-table-column
                    prop="vc_fpcode"
                    :label="$t('invoiceEntry_invoice_number')"
                    show-overflow-tooltip
                    min-width="180">
            </el-table-column>
            <el-table-column
                    prop="f_num"
                    :label="$t('invoiceEntry_order_quantity')"
                    show-overflow-tooltip
                    width="150"
                    align="right">
            </el-table-column>
            <el-table-column
                    prop="f_price_ws_cw"
                    :label="$t('invoiceEntry_order_pnit_price')"
                    show-overflow-tooltip
                    width="150"
                    align="right">
            </el-table-column>
            <el-table-column
                    prop="f_num_fp"
                    :label="$t('invoiceEntry_invoice_quantity')"
                    show-overflow-tooltip
                    width="150"
                    align="right">
            </el-table-column>
            <el-table-column
                    prop="f_price_ws_fp"
                    :label="$t('invoiceEntry_invoice_pnit_price')"
                    show-overflow-tooltip
                    width="150"
                    align="right">
            </el-table-column>
            <el-table-column
                    prop="f_je_ws_cw"
                    :label="$t('invoiceEntry_invoice_amount')"
                    show-overflow-tooltip
                    width="150"
                    align="right">
            </el-table-column>
            <el-table-column
                    prop="f_je_zzs_cw"
                    :label="$t('invoiceEntry_invoice_tax_amount')"
                    show-overflow-tooltip
                    width="150"
                    align="right">
            </el-table-column>
            <el-table-column
                    prop="projectName"
                    :label="$t('invoiceEntry_project_name')"
                    show-overflow-tooltip
                    min-width="210">
            </el-table-column>
            <el-table-column
                    prop="projectName"
                    :label="$t('invoiceEntry_specifications_and_origin')"
                    show-overflow-tooltip
                    min-width="210">
                <template slot-scope="scope">
                        <span class="fppm">{{scope.row.vc_pzname+' '+scope.row.vc_bzstyle+' '+scope.row.vc_cd+' '+scope.row.vc_gykh}}          </span>
                </template>
            </el-table-column>
            <el-table-column
                    align="center"
                    prop="vc_no"
                    :label="$t('form_batch_number')"
                    show-overflow-tooltip
                    width="130">
            </el-table-column>
            <el-table-column
                    prop="i_iswriteoff"
                    :label="$t('invoiceEntry_is_it_on_the_way')"
                    show-overflow-tooltip
                    width="80">
                <template slot-scope="scope">
                    <span >{{scope.row.i_iswriteoff==0?$t('form_deny'):$t('form_correct')}}</span>
                </template>
            </el-table-column>
           <!-- <el-table-column
                    prop="dt_fptime"
                    :label="$t('invoiceEntry_invoice_time')"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_lruname"
                    :label="$t('invoiceEntry_submitter')"
                    show-overflow-tooltip
                    width="118">
            </el-table-column>
            <el-table-column
                    prop="vc_mainfile_newname"
                    :label="$t('form_attachment')"
                    show-overflow-tooltip
                    width="55px">
                <template slot-scope="scope">
                    <a v-for="item in scope.row.files" :href="file_root+item.vc_mainfile_newname" target="_blank">
                        <i class="el-icon-paperclip" v-show="item.vc_mainfile_newname"></i>
                    </a>
                </template>
            </el-table-column>-->
            <el-table-column
                    width="60"
                    fixed="right"
                    :label="$t('form_operate')">
                <template slot-scope="scope">
                    <el-button  type="text" size="small" @click="goHx('hx',scope.row)">{{$t('invoiceEntry_write-off')}}</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
                style="display: flex;justify-content: flex-end;"
                class="mrr9 padT6"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-sizes="[20, 30, 50]"
                :page-size="pageSize"
                layout="sizes, prev, pager, next"
                :total="tableTotal">
        </el-pagination>
        <el-dialog
                :class="baseerp+'div'"
                :style="{ maxHeight: maxDialogHeight + 'px', overflowY: 'auto' }"
                top="15vh"
                width="85%"
                :title="$t('invoiceEntry_list')"
                :visible.sync="dialogVisible"
                :close-on-click-modal="false"
                @close="handleConfirmzt({type:'back'})"
                v-if="dialogVisible"
                :append-to-body="true">
            <addrk-list :Data="datark"  ref="dialogB" @confirmzt="handleConfirmzt"></addrk-list>
        </el-dialog>
    </div>
</template>

<script>
    import * as API from "./api";
    import {mapActions} from "vuex";
    import {baseerp} from "@/utils/baseUrl";
    import {file_root} from "@/utils/baseUrl";
    import addrkList from "./addlist";
    export default {
        components: {
            addrkList,
        },
        props: {
            ztData: {
                type: Object,
                required: true,
            }
        },
        data() {
            return {
                datark:{},
                loading:false,
                maxDialogHeight: 0,
                baseerp:"",
                file_root:"",
                mid:0,
                Data:{},
                dialogVisible:false,
                tableHeight:0,
                fpType:[
                    /*{i_type:2,vc_type:"采购发票"},
                    {i_type:3,vc_type:"运费发票"},
                    {i_type:32,vc_type:"港杂发票"},
                    {i_type:4,vc_type:"开证发票"},
                    {i_type:5,vc_type:"仓储发票"},
                    {i_type:6,vc_type:"保险发票"},*/
                ],
                i_type:0,
                i_khtype:0,
                vc_type:"",
                stateData:[
                    // {isover:'4',vc_name:'待处理'},
                    {i_checkstate:'0',vc_name:this.$t('state_tobe_submitted')},
                    {i_checkstate:'1',vc_name:this.$t('state_review_approved')},
                    {i_checkstate:'3',vc_name:this.$t('state_reviewing')},
                    {i_checkstate:'-2',vc_name:this.$t('state_review_not_approved')},
                ],
                //isover:'0',
                //vc_isover:this.$t('state_tobe_submitted'),
                i_checkstate:"0",
                vc_checkstate:this.$t('state_tobe_submitted'),
                kpfData:[],
                i_kpkhid:0,
                vc_kpkhname:'',
                compsData:[],
                companyName:'',
                companyId:0,
                vc_search:"",
                tableData:[{}],
                highlightCurrentRow:false,
                pageSize:30,
                currentPage:1,
                tableTotal:0,
                valuetime:'',
                dt_startdate:'',
                dt_enddate:'',
            }
        },
        watch: {

        },
        activated(){

        },
        mounted() {
            //console.log(this.ztData,'ztData');
            this.tableData=this.deepClone(this.ztData.data);
            this.baseerp=baseerp;
            this.file_root = file_root;
            this.$nextTick(function () {
                this.updateTableHeight();
                window.addEventListener('resize', this.updateTableHeight);
            });
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.updateTableHeight);
        },
        methods:{
            //...mapActions(["getCurrentMenuId"]),
            updateTableHeight() {
                //console.log(this.ztData.maxDialogHeight,'this.ztData.maxDialogHeight');
                const dialogHeight = this.ztData.maxDialogHeight * 0.95; // 弹窗最大高度
                //console.log(dialogHeight,' dialogHeight');
                const otherHeight =280;
                this.tableHeight = dialogHeight - otherHeight;
                //console.log( this.tableHeight,' this.tableHeight')
                this.maxDialogHeight =  this.ztData.maxDialogHeight;
            },
            deepClone(source) {
                if (typeof source !== 'object' || source == null) {
                    return source;
                }
                const target = Array.isArray(source) ? [] : {};
                for (const key in source) {
                    if (Object.prototype.hasOwnProperty.call(source, key)) {
                        if (typeof source[key] === 'object' && source[key] !== null) {
                            target[key] = this.deepClone(source[key]);
                        } else {
                            target[key] = source[key];
                        }
                    }
                }
                return target;
            },
            goHx(type,row){
                //console.log('row',row);
                if(type=='hx'){
                    this.title=this.$t('invoiceEntry_invoice_write-off')+row.vc_fpcode;
                }
                let remain={
                    f_num_fp:row.f_num_fp,
                    f_je_ws_cw:row.f_je_ws_cw,
                    f_je_zzs_cw :row.f_je_zzs_cw,
                }
                let map={
                    type:0,
                    row:row,
                    maxDialogHeight:this.maxDialogHeight,
                    remain:remain
                }
                this.datark=map;
                this.dialogVisible=true;
            },
            handleConfirmzt(selectedRows){
                //console.log(selectedRows,'selectedRows')
                this.dialogVisible=false;
                if (selectedRows.type == 'save') {
                    this.tableData=[];
                    this.ztfpList()
                }
            },

            async ztfpList(){
                let param={
                    'i_mid':this.mid,
                    "currentPage":this.currentPage,
                    "pageSize": this.pageSize,
                };
                var res = await API.getInvoiceInTransitList(param);
                if (res.code==1){
                    //console.log('res.data',res);
                    this.tableTotal=res.data.total;
                    this.tableData=res.data.list;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            //查询开票类型
            async fptype(){
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id;
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let param = {
                    i_mid:this.mid,
                };
                let res = await API.fptype(param);
                if (res.code == 1) {
                    this.fpType = res.data.list;
                    this.getfMou();
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            //获取开票方
            async getkhlist(){
                let param = {
                    vc_search:'',
                    i_khtype:this.i_khtype,
                };
                let res = await API.getkhlist(param);
                if (res.code == 1) {
                    this.kpfData = res.data.list;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },

            //获取交易公司
            async getCompanyList(){
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id;
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let param = {
                    i_mid:this.mid,
                };
                let res = await API.getCompanyList(param);
                if (res.code == 1) {
                    this.compsData = res.data;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            changeData(e,type){
                //console.log(e,type);
                if(type=='fpt'){
                    this.i_type=e;
                    let choo = this.fpType.filter(item=>{
                        return item.i_id == e
                    });
                    if(choo.length>0){
                        this.vc_type=choo[0].vc_name;
                        this.i_khtype=choo[0].i_khtype;
                        this.kpfData=[];
                        this.i_kpkhid=0;
                        this.vc_kpkhname='';
                        this.getkhlist();
                    }else{
                        this.vc_type='';
                        this.i_khtype=0;
                        this.kpfData=[];
                        this.i_kpkhid=0;
                        this.vc_kpkhname='';
                    }
                    //刷新列表
                }
                if(type=='state'){
                    this.i_checkstate=e;
                    let choo = this.stateData.filter(item=>{
                        return item.i_checkstate == e
                    });
                    //console.log(choo,'choo');
                    if(choo.length>0){
                        this.vc_checkstate=choo[0].vc_name;
                    }else{
                        this.vc_checkstate='';
                    }
                    //刷新列表
                }
                if(type=='kpf'){
                    if(this.i_khtype==0){
                        this.$message.error(this.$t('invoiceEntry_please_select_the_invoice_type_first'));
                    }else{
                        this.i_kpkhid=e;
                        let choo = this.kpfData.filter(item=>{
                            return item.i_id == e
                        });
                        //console.log(choo,'choo');
                        if(choo.length>0){
                            this.vc_kpkhname=choo[0].vc_name;
                        }else{
                            this.vc_kpkhname='';
                        }
                        //刷新列表
                    }
                }
                if(type=='gs'){
                    this.companyId=e;
                    let choo = this.compsData.filter(item=>{
                        return item.i_id == e
                    });
                    //console.log(choo,'choo');
                    if(choo.length>0){
                        this.companyName=choo[0].vc_name;
                    }else{
                        this.companyName='';
                    }
                    //刷新列表
                }
                this.ztfpList();
            },
            gosearch(){
                //console.log("搜索",this.vc_search);
                //console.log("公司",this.companyId);
                this.currentPage=1;
                this.tableData=[];
                this.ztfpList();
            },
            clearsearch(type){
                if(type=='fpt') {
                    this.i_type=0;
                    this.vc_type='';
                    this.i_khtype = 0;
                    this.i_kpkhid = 0;
                    this.vc_kpkhname = '';
                    this.kpfData=[];
                }
                if(type=='state'){
                    this.i_checkstate=null;
                    this.vc_checkstate='';
                }
                if(type=='kpf') {
                    this.i_kpkhid = 0;
                    this.vc_kpkhname = '';
                }
                if(type=='gs'){
                    this.companyId=0;
                    this.companyName="";
                }
                if(type=='sou'){
                    this.vc_search=""
                }
                this.currentPage=1;
                this.tableData=[];
                this.ztfpList();
            },
            handleSizeChange(val){
                this.pageSize=val;
                this.currentPage=1;
                this.ztfpList();
            },
            handleCurrentChange(val){
                this.currentPage=val;
                this.ztfpList();
            },
            //获取当前月的第一天
            getfMou(){
                let today = new Date();
                let firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
                //console.log(firstDay,today);
                let map = [firstDay,today];
                this.valuetime=map;
                //console.log(this.valuetime)
                this.dt_startdate= this.formatDate( this.valuetime[0]);
                this.dt_enddate= this.formatDate( this.valuetime[1]);
                //this.ztfpList();
            },
            formatTen(num) {
                return num > 9 ? (num + "") : ("0" + num);
            },
            formatDate(date) {
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                var day = date.getDate();
                var hour = date.getHours();
                var minute = date.getMinutes();
                var second = date.getSeconds();
                return year + "-" + this.formatTen(month) + "-" + this.formatTen(day);
            },
            getTimes(e){
                //console.log(e)
                if(e){
                    this.dt_startdate= this.formatDate(e[0]);
                    this.dt_enddate= this.formatDate(e[1]);
                    //console.log(this.dt_startdate,this.dt_enddate);
                }else{
                    this.dt_startdate= '';
                    this.dt_enddate= '';
                }
                //this.currentPage=1;
                //this.tableData=[];
                //this.ztfpList();
            },
        },
    }
</script>

<style  lang="scss" scoped>
    /deep/.el-table td.is-right, .el-table th.is-right {
        text-align: right !important;
    }
    .pm{
        height: calc(100vh - 145px);
        /*overflow: auto;*/
    }
    .video-tree,.tabsList,.taskList{
        height: 100%;
    }
    .icon{
        position: absolute;
        top: 30%;
        width: 20px;
        height: 20px;
        z-index: 1000;
        padding: 0;
        border-radius:0px;
    }
    .right{
        left: -19px;
        border-right: none;
    }
    .left{
        left: -10px;
        border-left: none;
    }
    .position{
        position: relative;
    }
    //css
    //弹窗窗口
    /deep/.cgdia {
        .el-dialog {
            max-height: 90vh !important;    /* 弹窗最大高度为视口高度的90% */
            overflow: auto;        /* 内容超出时滚动 */
        }
        .el-dialog__body {
            max-height: calc(90vh - 100px) !important;/* 减去头部和底部的空间 */
            overflow-y: auto;
            padding: 0 20px 0 20px;
        }
        .el-dialog__headerbtn .el-dialog__close{
            color: white;
        }
        .el-dialog__title{
            color: white;
        }

    }
    /deep/{
        .el-dialog__body{
            padding: 6px 10px !important;
        }
    }

    .alc{
        align-items: center;
    }
    .font14{
        font-size: 14px;
        color: grey;
        min-width:58px;
    }
    .box{
        width: 24px;
        height: 24px;
        line-height: 24px;
    }
    .boxyu{
        //background-color:var(--themeColor);
        background-color: #fa5050;
        border-radius: 4px;
        padding: 1px 4px;
        color: #fff;
        font-size: 14px;
    }
    .flex_b{
        display: flex;
        justify-content: space-between;
    }
    .flex{
        display: flex;
    }
    .fr{
        float: right;
    }
    .mrr9{
        margin-right: 9px;
    }
    .padT6{
        //padding: 6px 0;
    }
    .pad14{
        padding: 3px 9px;
    }
    .w100{
        width: 100%;
    }
    .marr4{
        margin-right: 4px;
    }
</style>